import apiInternal from '@services/axios-internal';
import { AddRaffleParticipantResponse } from '@types';

export const apiRaffleAddParticipant = async (
  newParticipant: string,
): Promise<AddRaffleParticipantResponse> => apiInternal.put('/api/raffle', { newParticipant });
